/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const DEFAULT_COLUMNS: string[] = [
	'issuetype',
	'issuekey',
	'summary',
	'reporter',
	'assignee',
	'status',
	'created',
];

export const DEFAULT_QUEUE_ID: number = Number.MIN_VALUE;

// The number of issue keys that would be fetched on scroll on queues agent view
export const FETCH_BATCH_SIZE_OLD = 100;

export const FETCH_SIZE_IN_INITIAL_LOAD = 30;
